var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"PrivacyP"}},[_c('b-container',[_c('h3',{staticClass:"title"},[_vm._v("Terms and Conditions")]),_c('p',{staticClass:"description"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }